import { takeEvery, takeLatest } from 'typed-redux-saga';
import addProductToMyWishlistApiSaga from '@spa/lib/store/sagas/api/wishlist/addProductToMyWishlistApiSaga';
import { apiAddProductToMyWishlistRequestedType } from '@spa/lib/store/api/wishlists/addProductToMyWishlistApi';
import { apiCreateMyWishlistRequestedType } from '@spa/lib/store/api/wishlists/createMyWishlistApi';
import { apiDeleteMyWishlistRequestedType } from '@spa/lib/store/api/wishlists/deleteMyWishlistApi';
import { apiDeleteProductFromMyWishlistRequestedType } from '@spa/lib/store/api/wishlists/deleteProductFromMyWishlistApi';
import { apiGetMyWishlistsRequestedType } from '@spa/lib/store/api/wishlists/getMyWishlistsApi';
import { apiUpdateMyWishlistRequestedType } from '@spa/lib/store/api/wishlists/updateMyWishlistApi';
import { apiUpdateProductQuantityFromMyWishlistRequestedType } from '@spa/lib/store/api/wishlists/updateProductQuantityFromMyWishlistApi';
import createMyWishlistApiSaga from '@spa/lib/store/sagas/api/wishlist/createMyWishlistApiSaga';
import deleteMyWishlistApiSaga from '@spa/lib/store/sagas/api/wishlist/deleteMyWishlistApiSaga';
import deleteProductFromMyWishlistApiSaga from '@spa/lib/store/sagas/api/wishlist/deleteProductFromMyWishlistApiSaga';
import getMyWishlistsApiSaga from '@spa/lib/store/sagas/api/wishlist/getMyWishlistsApiSaga';
import updateMyWishlistApiSaga from '@spa/lib/store/sagas/api/wishlist/updateMyWishlistApiSaga';
import updateProductQuantityFromMyWishlistApiSaga from '@spa/lib/store/sagas/api/wishlist/updateProductQuantityFromMyWishlistApiSaga';

function* wishlistApiSaga(): Generator {
  yield* takeLatest(apiGetMyWishlistsRequestedType, getMyWishlistsApiSaga);
  yield* takeEvery(apiCreateMyWishlistRequestedType, createMyWishlistApiSaga);
  yield* takeEvery(apiDeleteMyWishlistRequestedType, deleteMyWishlistApiSaga);
  yield* takeEvery(apiUpdateMyWishlistRequestedType, updateMyWishlistApiSaga);
  yield* takeEvery(apiDeleteProductFromMyWishlistRequestedType, deleteProductFromMyWishlistApiSaga);
  yield* takeEvery(apiAddProductToMyWishlistRequestedType, addProductToMyWishlistApiSaga);
  yield* takeEvery(
    apiUpdateProductQuantityFromMyWishlistRequestedType,
    updateProductQuantityFromMyWishlistApiSaga
  );
}

export default wishlistApiSaga;
